import { Link } from "react-router-dom";

export default function CommuneIndex({ cities }) {
  const groups = cities.reduce((acc, c) => {
    (acc[c.department] = acc[c.department] || []).push(c);
    return acc;
  }, {});
  return (
    <section className="py-16 bg-secondary/40 rounded-3xl mx-3 md:mx-6" data-testid="commune-index">
      <div className="container-tm">
        <h2 className="h-section">Conciergerie Airbnb : <span className="text-accent">toutes les communes</span></h2>
        <p className="mt-3 text-muted-foreground">Trouvez la page de votre commune : rentabilité Airbnb et devis conciergerie gratuit.</p>
        <div className="mt-10 space-y-10">
          {Object.entries(groups).map(([dept, list]) => (
            <div key={dept}>
              <h3 className="font-bold text-lg" style={{ fontFamily: "Quicksand, sans-serif" }}>
                Conciergerie {dept} <span className="text-muted-foreground font-normal text-sm">({list.length})</span>
              </h3>
              <ul className="mt-3 columns-2 sm:columns-3 lg:columns-5 gap-6 text-sm">
                {[...list].sort((a, b) => a.name.localeCompare(b.name, "fr")).map((c) => (
                  <li key={c.slug} className="py-0.5 break-inside-avoid">
                    <Link to={`/villes/${c.slug}`} className="text-foreground/75 hover:text-accent transition-colors">{c.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
